<template>
  <div v-loading.body="loading">
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
          >
            {{ filterFold ? "展开筛选" : "收起筛选" }}
          </el-button>
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form ref="form" :model="form" label-width="85px">
                <el-row :gutter="10">
                  <el-col>
                    <el-form-item label="输入搜索：">
                      <el-col :span="2">
                        <el-select
                          v-if="address"
                          v-model="form.city"
                          placeholder="发货仓"
                        >
                          <el-option
                            v-for="item1 in address"
                            :key="item1.key"
                            :label="item1.label"
                            :value="item1.key"
                          ></el-option>
                        </el-select>
                      </el-col>
                      <el-col :span="2">
                        <el-input
                          v-model="form.order_sn"
                          placeholder="订单号"
                          @keyup.native.enter="search"
                        ></el-input>
                      </el-col>
                      <el-col :span="2">
                        <el-input
                          v-model="form.work_id"
                          placeholder="工单id"
                          @keyup.native.enter="search"
                        ></el-input>
                      </el-col>
                      <el-col :span="3">
                        <el-input
                          v-model="form.goods_name"
                          placeholder="商品名称"
                          @keyup.native.enter="search"
                        ></el-input>
                      </el-col>
                      <el-col :span="3">
                        <el-input
                          v-model="form.goods_no"
                          placeholder="货号"
                          @keyup.native.enter="search"
                        ></el-input>
                      </el-col>
                      <el-col :span="3">
                        <el-input
                          v-model="form.handle_admin"
                          placeholder="处理人"
                          @keyup.native.enter="search"
                        ></el-input>
                      </el-col>
                      <el-col :span="3">
                        <el-select
                          v-if="resData"
                          v-model="form.handle_status"
                          placeholder="状态"
                        >
                          <el-option label="全部" value=""></el-option>
                          <el-option label="待处理" value="1"></el-option>
                          <el-option label="已处理" value="2"></el-option>
                        </el-select>
                      </el-col>
                      <el-col :span="3">
                        <el-input
                          v-model="form.create_admin"
                          placeholder="创建人"
                          @keyup.native.enter="search"
                        ></el-input>
                      </el-col>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="10">
                  <el-col :span="7">
                    <el-form-item label="生成时间：">
                      <el-date-picker
                        v-model="form.add_time"
                        type="datetimerange"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :default-time="['06:00:00', '06:00:00']"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="10">
                  <el-col :span="7">
                    <el-form-item label="拆包时间：">
                      <el-date-picker
                        v-model="form.create_time"
                        type="datetimerange"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :default-time="['06:00:00', '06:00:00']"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="10">
                  <el-col :span="7">
                    <el-form-item label="处理时间：">
                      <el-date-picker
                        v-model="form.handle_time"
                        type="datetimerange"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :default-time="['06:00:00', '06:00:00']"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="10">
                  <el-col :span="2">
                    <el-button type="primary" @click="search">查询</el-button>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>

    <!-- 表格 -->
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>数据列表：</div>
          <el-button
            style="margin-left: auto"
            type="success"
            size="mini"
            @click="output"
            >导出</el-button
          >
        </div>
        <div v-if="resData" style="margin-bottom: 0">
          <el-table
            ref="multipleTable"
            v-loading="tableLoading"
            height="600"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              prop="create_admin_name"
              label="异常工单创建人"
              align="center"
              width="100"
            >
            </el-table-column>
            <el-table-column
              prop="create_time"
              label="拆包时间"
              align="center"
              width="100"
            >
            </el-table-column>
            <el-table-column
              prop="order_sn"
              label="订单号"
              align="center"
              width="100"
            >
            </el-table-column>
            <el-table-column
              prop="work_id"
              label="工单ID"
              align="center"
              width="100"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="small"
                  @click="
                    handleClick(scope.row.work_id, scope.row.user_refund_id)
                  "
                  >{{ scope.row.work_id }}</el-button
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="service_order_handle_type"
              label="工单类型"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="add_time"
              label="工单生成时间"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="goods_name"
              label="商品名称"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="back_shipping_num"
              label="商品图片"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <div style="width: 70px; height: 70px">
                  <img
                    :src="scope.row.goods_img"
                    style="width: 100%; height: 100%"
                    @click="showImages(scope.row.imgs)"
                  />
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="goods_no"
              label="货号"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="co_val"
              label="颜色"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="si_val"
              label="尺码"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="goods_number"
              label="工单件数"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="unpacking_num"
              label="已拆包件数"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="handle_admin"
              label="处理人"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="handle_remark"
              label="处理人备注"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="handle_time"
              label="处理时间"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop=""
              label="操作"
              align="center"
              width="100"
              fixed="right"
            >
              <template slot-scope="scope">
                <div v-if="scope.row.status == 1">
                  <el-button
                    size="small"
                    type="primary"
                    @click="handleAbnormalWork(scope.row.abnormal_id)"
                    >待处理</el-button
                  >
                </div>
                <div v-if="scope.row.status == 2">
                  <el-button size="small" type="info">已完成</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper "
            :total="resData.count"
            :page-size="10"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <preview-image
      :imgs="images"
      :show="showbox"
      @closeBox="closeBox()"
    ></preview-image>
  </div>
</template>

<script>
import PreviewImage from "../../components/PreviewImage";
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  components: { PreviewImage },
  data() {
    return {
      showbox: false,
      images: [],
      resData: null,
      form: {
        create_time: this.defaultDate(),
        status: "",
        referer: 1,
      },
      loading: false, // 加载动画是否显示
      url: "/erp/Work/abnormalWorkList",
      status: "",
      curPage: 1,
      tableLoading: false,
      filterFold: false,
      address: [
        {
          key: "",
          label: "全部",
        },
        {
          key: "1",
          label: "广州",
        },
        {
          key: "2",
          label: "杭州",
        },
      ],
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  mounted() {
    this.form.create_time = this.defaultDate();
    this.fetchData();
  },
  methods: {
    defaultDate() {
      return this.$excalibur.getDateTimeOnHours(-15, 6);
    },
    showImages(img) {
      this.showbox = true;
      this.images = img;
    },
    closeBox() {
      this.showbox = false;
    },
    handleAbnormalWork(abnormal_id) {
      this.$prompt("填写备注", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        showInput: true,
      })
        .then(({ value }) => {
          if (!value) {
            return this.$message.warning("请填写备注");
          }
          const arg = { abnormal_id, remark: value };
          this.loading = true;
          this.$http
            .post("/erp/Work/changeAbnormalWorkStatus", arg)
            .then((res) => {
              this.loading = false;
              if (res.data.code != 200) {
                return this.$message({
                  type: "error",
                  message: res.data.msg,
                });
              }
              this.fetchData();
              return this.$message({
                type: "success",
                message: "操作成功",
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
    },
    handleClick(work_id, user_refund_id) {
      let host = "http://test2.yishou.com";
      let redirect_url = `/Ysadmin/ServiceOrder/all_list?select_type=service_order_id&select_type_value=${work_id}`;
      if (user_refund_id > 0) {
        redirect_url = `/Ysadmin/UserService/user_refund?r_start_time=2018-01-01 00:00:00&service_order_id=${work_id}`;
      }
      if (
        window.location.hostname == "erp.yishouapp.com" ||
        window.location.hostname == "erpweb.yishouapp.com"
      ) {
        redirect_url = `/ServiceOrder/all_list?select_type=service_order_id&select_type_value=${work_id}`;
        if (user_refund_id > 0) {
          redirect_url = `/UserService/user_refund?r_start_time=2018-01-01 00:00:00&service_order_id=${work_id}`;
        }
        host = "https://d0k0.yishouapp.com";
      }
      const url = host + redirect_url;
      window.open(url);
    },
    output() {
      this.form.is_excel = 1;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.form.is_excel = 0;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.form.is_excel = 0;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            window.open(apiBaseURL + res.data.data.file);
          }
        }
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    fetchData(showLoading) {
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    onSubmit() {},
    handleCurrentChange(val) {
      this.form.page = val;
      this.loading = true;
      this.$http.post(this.url, this.form).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    search() {
      this.form.page = 1;
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
          (this.status = this.filteredForm.status), (this.curPage = 1);
        }
      });
    },
    selectStatus(key) {
      this.form.status = this.status = key;
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1 px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}

.demo-form-inline .el-form-item {
  margin-left: 40px;
}
</style>



// WEBPACK FOOTER //
// src/pages/work/AbnormalWorkList.vue